import template from './evaluation.html'

let component = {
	template: template,
	bindings: {
		modal: '='
	},
	controller: function(
		$scope,
		$timeout,
		$state,
		$filter,
		Basket,
		Customer,
		$rootScope,
		$ionicPlatform
	) {
		'ngInject'

		var session;
		var vm = this;

		vm.show = false;
		vm.page = 1;

		vm.labels = {
			done: {
				nl: 'Gereed',
				en: 'Done'
			},
			cancel: {
				nl: 'Annuleren',
				en: 'Cancel'
			},
			skip: {
				nl: 'Overslaan',
				en: 'Skip'
			}
		}

		vm.language = $rootScope.language;
		
		vm.questions = [
			{
				nl: $filter('translate')('evaluation_text_1', 'nl'),
				en: $filter('translate')('evaluation_text_1', 'en'),
				type: 'emoticons'
			}, 
			{
				nl: $filter('translate')('evaluation_text_2', 'nl'),
				en: $filter('translate')('evaluation_text_2', 'en'),
				type: 'scale'
			}
		];

		vm.finish = [
			{
				nl: $filter('translate')('evaluation_text_3', 'nl'),
				en: $filter('translate')('evaluation_text_3', 'en')
			},
			{
				nl: $filter('translate')('evaluation_text_4', 'nl'),
				en: $filter('translate')('evaluation_text_4', 'en')
			},
			{
				nl: $filter('translate')('evaluation_text_5', 'nl'),
				en: $filter('translate')('evaluation_text_5', 'en')
			}
		];

		vm.cancel = function() {
			reset();
		}

		vm.toggleLanguage = function() {
			vm.language = vm.language === 'nl' ? 'en' : 'nl';
		}

		vm.done = function() {
			session = Customer.session();

			Customer.saveEvaluation({
				customer_session_id:session.id,
				answer1:vm.questions[0].answer,
				answer2:vm.questions[1].answer,
				feedback:vm.feedback
			}).then(function() {
				reset();
			}).catch(console.log);
			
		}

		vm.answer = function(question, answer) {
			question.answer = answer;
			$timeout(function() {
				vm.page++;
			},500);
		}

		function reset() {
			vm.page = 1;
			vm.show = false;
			vm.feedback = undefined;
			vm.questions.forEach(function(question) {
				question.answer = undefined;
			});
			vm.modal.remove();
			Customer.flush();
			$state.go('tab.home');
		}


		window.addEventListener('native.keyboardhide', function(){
			vm.keyboard = false;
			$scope.$apply();
		});

		window.addEventListener('native.keyboardshow', function(){
			vm.keyboard = true;
			$scope.$apply();
		});
	}
}

export default component;


// WEBPACK FOOTER //
// ./app/components/evaluation/evaluation.component.js